import { useBreakpoints } from '.';
export const useBreakpointValues = (breakpointValues) => {
    const { active } = useBreakpoints();
    if (typeof breakpointValues === 'object') {
        return breakpointValues[active];
    }
    return breakpointValues;
};
